module.exports = __webpack_public_path__ + "img/floppy-disk.09e80521.svg";